<template>
  <div class="self_element_style_qja_a_this">
    <basic-container>
      <div class="form_wrapper">
        <div class="form_header">
          <div class="form_header_name">
            {{ title }}
          </div>
          <div class="form_header_remarks">
            带<span class="red_color">* </span>为必填项
          </div>
        </div>
        <div class="form_content">
          <avue-form :option="option" ref="form" v-model="form">
            <template slot="group1Header">
              <div class="label_name">基础信息</div>
            </template>
            <template slot="group2Header">
              <div class="label_name">财务信息</div>
            </template>
            <template slot="group3Header">
              <div class="label_name">基金管理人</div>
            </template>

            <template slot="region">
              <el-cascader
                :props="props"
                :key="modakay"
                @change="regionChange"
                placeholder="请选择所在地区"
                emitPayh="true"
                :value="region"
              ></el-cascader>
            </template>

            <template slot="menuForm">
              <el-button
                type="primary"
                icon="el-icon-check"
                size="small"
                :loading="loading"
                @click="handleSubmit"
                >保存</el-button
              >
            </template>
          </avue-form>
        </div>
      </div>
    </basic-container>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />
  </div>
</template>

<script>
import {
  isvalidatemobile,
  isvalidateMoney,
  isvalidatePercentage,
} from "@/util/validate";
import { downLoadTemplate } from "@/router/downLoadTem";
import * as api from "@/api/fund/subfunds";
import * as dictionaries from "@/api/zd/dictionaries";
import { mapGetters } from "vuex";
import SelectPerson from "@/components/SelectPersonnel/person";

export default {
  name: "thirdRegister",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value != "" && isvalidatemobile(value)[0]) {
        callback(new Error(isvalidatemobile(value)[1]));
      } else {
        callback();
      }
    };
    // 规则
    const validateCompare=(rule, value, callback) =>{
    if (this.form.peScale && this.form.govIndustrySubscribed&&(parseFloat(this.form.peScale) < parseFloat(this.form.govIndustrySubscribed))) {
      callback(new Error("基金认缴规模必须大于等于政府产业基金认缴金额"));
    }else {
        callback();
      }

    };
    return {
      form: { manager: {} },
      region: ["浙江省", "台州市", "椒江区"],
      modakay: 0,
      props: {
        lazy: true,
        label: "name",
        value: "name",
        lazyLoad(node, resolve) {
          let level = node.level;
          let data = node.data || {};
          let code = data.id;
          let list = [];
          let callback = () => {
            resolve(
              (list || []).map((ele) => {
                return Object.assign(ele, {
                  leaf: level >= 2,
                });
              })
            );
          };

          dictionaries
            .district({
              level: level,
              pid: code,
            })
            .then((res) => {
              list = res.data.data;
              callback();
            });
        },
      },
      option: {
        labelWidth: 200,
        emptyBtn: false,
        submitBtn: false,
        group: [
          {
            icon: "el-icon-info",
            label: "分组1",
            prop: "group1",

            column: [
              {
                label: "子基金名称",
                prop: "name",
                placeholder: "请输入子基金名称",
                rules: [
                  {
                    required: true,
                    message: "请输入子基金名称",
                    trigger: "blur",
                  },
                ],
              },
              {
                label: "设立时间",
                prop: "establishmentTime",
                type: "date",
                rules: [
                  {
                    required: true,
                    message: "请选择设立时间",
                    trigger: "blur",
                  },
                ],
                format: "yyyy-MM-dd",
                valueFormat: "yyyy-MM-dd",
              },
              {
                label: "母基金名称",
                prop: "masterId",
                type: "select",
                filterable: "true",
                dicUrl: "/api/fund/fdproject/dict",
                dicMethod: "get",
                dicQuery: {
                  fundType:1,
                  // auditState:2,
                },
                remote: true,
                dicFormatter: (res) => {
                  return res.data; //返回字典的层级结构
                },
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
                rules: [
                  {
                    required: true,
                    message: "请选择母基金",
                    trigger: "change",
                  },
                ],
              },
              {
                label: "合作方式",
                prop: "cooperateType",
                type: "select",
                dicUrl:
                  "/api/blade-system/dict-biz/dictionary?code=cooperate_type",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
              },
              {
                label: "投后报告周期",
                prop: "manageCycle",
                type: "select",
                dicUrl:
                  "/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
                
              },
              {
                label: "基金状态",
                prop: "fundState",
                type: "select",
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=fund_state",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
              },             

              {
                label: '基金大类',
                type: 'select',
                prop: 'fundTargetType',
                valueDefault: 1,
                dicData: [{
                  value: 1,
                  name: "政府产业基金"
                },
                {
                  value: 0,
                  name: "纾困基金"
                }],
                props: {
                  label: "name",
                  value: "value"
                },
                rules: [{
                  required: false,
                  message: '请选择基金大类',
                  trigger: 'change'
                }]
              },
              {
                label: "基金类型",
                type: "select",
                prop: 'isDirectional',
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=subFund_type",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                }
              },
              {
                label: "投资期截止日期",
                prop: "investEndDate",
                type: "date",
                
                format: "yyyy-MM-dd",
                valueFormat: "yyyy-MM-dd",
              },
              {
                label: "退出期截止日期",
                prop: "quitEndDate",
                type: "date",
                
                format: "yyyy-MM-dd",
                valueFormat: "yyyy-MM-dd",
              },                         
            ],
          },
          {
            icon: "el-icon-info",
            label: "分组2",
            prop: "group2",
            type: "number",
            column: [
              {
                label: "管理费收取模式",
                prop: "manageIncomeType",
                type:'textarea',
                row:true,
                span:24,
                
              },
              {
                label: "基金认缴规模",
                prop: "peScale",
                prepend: "￥",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入";
                },
                rules: [
                  {
                    required: true,
                    message: "请输入基金认缴规模",
                    trigger: "blur",
                  },
                  { validator: isvalidateMoney, trigger: "blur" },
                  {
                    validator: validateCompare,
                    trigger: "change"
                  },
                ],
              },
              {
                label: "基金实缴金额",
                prop: "totalCapitalPaid",
                prepend: "￥",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入";
                },
                rules: [
                  {
                    required: true,
                    message: "请输入基金实缴金额",
                    trigger: "blur",
                  },
                  { validator: isvalidateMoney, trigger: "blur" },
                ],
              },
              {
                label: "基金已投金额",
                prop: "allFundAmount",
                disabled: true,
                prepend: "￥",
                placeholder: "等待生成",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value ? this.changeNumMoneyToChinese(value) : "";
                },
              },
              {
                label: "已收回金额",
                prop: "fundQuidAmount",
                disabled: true,
                prepend: "￥",
                placeholder: "等待生成",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value ? this.changeNumMoneyToChinese(value) : "";
                },
              },
              
              {
                label: "政府产业基金认缴金额",
                prop: "govIndustrySubscribed",
                prepend: "￥",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入";
                },
                rules: [
                  {
                    required: true,
                    message: "请输入政府产业基金认缴额",
                    trigger: "blur",
                  },
                  { validator: isvalidateMoney, trigger: "blur" },
                  {
                    validator: validateCompare,
                    trigger: "change"
                  },
                ],
              },
              {
                label: "政府产业基金实缴金额",
                prop: "realGovIndustrySubscribed",
                prepend: "￥",
                disabled: false,
                placeholder: "请输入政府产业基金实缴金额",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value ? this.changeNumMoneyToChinese(value) : "";
                },
              },
              {
                label: "社会资本认缴额",
                prop: "otherCapitalSubscribed",
                prepend: "￥",
                disabled: true,
                placeholder: "等待生成",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入";
                },
                formatter: (row, value, label, column) => {},
                rules: [
                  {
                    required: true,
                    message: "请输入社会资本认缴额",
                    trigger: "blur",
                  },
                  { validator: isvalidateMoney, trigger: "blur" },
                ],
              },
              {
                label: "社会资本实缴额",
                prop: "realotherCapitalSubscribed",
                prepend: "￥",  
                disabled: true,
                placeholder: "等待生成",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value ? this.changeNumMoneyToChinese(value) : "";
                },
              },
              {
                label: "带动社会投资额",
                prop: "allSocietyAmount",
                prepend: "￥",
                disabled: true,             
                value: 0,
                rules: [
                  {
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                  },
                ],
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value ? this.changeNumMoneyToChinese(value) : "";
                },
              },
              {
                label: "政府产业基金出资占比",
                prop: "capitalRatio",
                placeholder: "等待生成",
                disabled: true,    
                append: "%",
                // rules: [
                //   // {
                //   //   required: true,
                //   //   message: "请输入",
                //   //   trigger: "blur",
                //   // },
                //   { validator: isvalidatePercentage, trigger: "blur" },
                // ],
              }
            ],
          },
          {
            icon: "el-icon-info",
            label: "分组3",
            prop: "group3",

            column: [
              {
                label: "基金管理人名称",
                prop: "managerStr",
                bind: "manager.name",
                placeholder: "请输入基金管理人名称",
                rules: [
                  {
                    required: true,
                    message: "请输入基金管理人名称",
                    trigger: "blur",
                  },
                ],
              },
              {
                label: "基金协会编码",
                prop: "orgCode",
                bind: "manager.orgCode",
                placeholder: "请输入基金协会编码",

                
              },
              {
                label: "所在地区",
                prop: "region",
                bind: "manager.region",
                formslot: true,
                type: "cascader",
              },

              {
                label: "所在地址",
                prop: "address",
                bind: "manager.address",
              },
              {
                label: "成立时间",
                prop: "mestablishmentTime",
                bind: "manager.establishmentTime",
                type: "date",
                clearable: false,
                format: "yyyy-MM-dd",
                valueFormat: "yyyy-MM-dd",
              },
              {
                label: "纳税识别号",
                prop: "creditCode",

                bind: "manager.creditCode",
                placeholder: "请输入纳税识别号",
              },
              {
                label: "联系人",
                prop: "contactPerson",
                bind: "manager.contactPerson",
                placeholder: "请输入联系人",
              },
              {
                label: "职务信息",
                prop: "duty",
                bind: "manager.duty",
                placeholder: "请输入职务信息",
              },
              {
                label: "联系号码",
                prop: "contactInfo",
                bind: "manager.contactInfo",
                rules: [{ validator: validatePhone, trigger: "blur" }],
              },
            ],
          },
        ],
      },
      id: -1,
      projectList: [],
      checkUserList: [],
      peopleList: "",
      file: -1,
      projectDisabled: false,
    };
  },

  components: {
    SelectPerson,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    title() {
      return this.$route.params.id === "-1" ? "新增子基金" : "编辑子基金";
    },
    dateRange() {
      
      const { peScale,govIndustrySubscribed } = this.form;
      return { peScale,govIndustrySubscribed  };
    },
  },
  watch: {
      dateRange: {
      handler(data) {
        this.$nextTick(() => {
          
          if (this.form.peScale && this.form.govIndustrySubscribed ) {
            if(parseFloat(this.form.peScale)>=parseFloat(this.form.govIndustrySubscribed)){
               this.form.otherCapitalSubscribed=this.form.peScale-this.form.govIndustrySubscribed 
               this.form.capitalRatio=(this.form.govIndustrySubscribed/this.form.peScale*100).toFixed(2)
            }else {
                this.form.otherCapitalSubscribed=""
                this.form.capitalRatio=""
            }
            
          }
        });
      },
      deep: true,
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.form.manager.region = this.region.join(',');
    if (this.id > -1) {
      this.getInfo();
    }
  },

  methods: {
    
    getInfo() {
      let that = this;
      api
        .getDetail(this.id)
        .then((res) => {
          let form = res.data.data;
          this.region = form.manager.region
            ? form.manager.region.split(",")
            : [];
          this.form = form;

          this.form.manageCycle = form.manageCycle?`${form.manageCycle}`:''
          this.form.fundState = form.fundState?`${form.fundState}`:''
          this.form.cooperateType = form.cooperateType?`${form.cooperateType}`:''
          this.form.manageCycle = form.manageCycle?`${form.manageCycle}`:''
          this.form.isDirectional = this.form.isDirectional.toString()
          this.$nextTick(() => {
            this.modakay++;
          });
        })
        .catch((res) => {
          console.log(res);
        });
    },
    regionChange(value) {
      this.form.manager.region = value.join(',');
    },

    //提交
    handleSubmit() {
      let self = this
      this.$refs['form'].validate((valid1,done1) => {
        if(valid1){
          self.saveData()
          done1()
        }
      })
    },
    
    saveData() {
      let data = {
        ...this.form,
        id: this.id > -1 ? this.id : undefined,
      };
      api.submit(data).then(
        (res) => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });

         
          this.$router.push({
            path: `/fund/subfunds/detail/${res.data.data.id}`,
          });
        },
        (error) => {
          window.console.log(error);
        }
      );
    }
  },
};
</script>

<style lang="scss" scoped>
.form_wrapper {
  height: 100%;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;
  margin-bottom: 50px;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 14px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    margin-bottom: 50px;
    padding: 20px 50px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }
}
.btn_save {
  text-align: center;
}
.file_wrapper {
  display: flex;
  align-items: center;
  min-height: 35px;
  .file_button {
    display: contents;
    color: #333333;
    font-weight: 400;
    &:hover {
      color: #409eff;
    }
  }
}
.del_icon {
  margin-left: 20px;
  cursor: pointer;
}
</style>

<style>
.self_element_style_qja_a_this .el-card.is-always-shadow {
  background-color: #f0f2f5;
}
.self_element_style_qja_a_this .el-button {
  width: 140px;
}
.self_element_style_qja_a_this .avue-group {
  pointer-events: none;
}
.self_element_style_qja_a_this .el-collapse-item__wrap {
  pointer-events: all;
}
.avue-group {
  pointer-events: none;
}
.el-collapse-item__wrap {
  pointer-events: all;
}
.avue-group__header {
  border-bottom: none;
}
.avue-group .el-collapse-item__arrow {
  display: none;
}
</style>
